import { SectionBody, SectionHeader, SectionTitle } from './components';
import { ISectionStyles, useSectionStyles } from '../../../assets/layouts';

export interface SectionProps extends React.FormHTMLAttributes<HTMLDivElement> {
}

const Section: React.FC<SectionProps> = (props) => {
    const styles: ISectionStyles = useSectionStyles();
    const className: string = props.className ?? "mb-4";

    return (
        <div {...props} className={className} style={{ ...styles.container, ...props.style }} />
    );
};

export default Object.assign(Section, {
    Body: SectionBody,
    Header: SectionHeader,
    Title: SectionTitle
});